@if (!accepted()) {
  <div class="gdpr-banner">
    @switch (mode()) {
      @case (GdprBannerMode.Preview) {
        <div class="banner-content">
          <h3>{{ "shared.gdpr.preview.title" | translate }}</h3>
          <p>
            <app-i18n-html
              [text]="
                'shared.gdpr.preview.description'
                  | translate
                    : {
                        href: 'https://inseer-public-videos.s3.us-east-2.amazonaws.com/Cookie+Privacy+Policy+Additions.docx.pdf',
                      }
              "
            />
          </p>
          <div class="button-group">
            <div class="button-row">
              <button class="btn-reject" (click)="gdprFacade.rejectAll()">
                {{ "shared.gdpr.preview.reject_button" | translate }}
              </button>
              <button class="btn-accept" (click)="gdprFacade.acceptAll()">
                {{ "shared.gdpr.preview.accept_button" | translate }}
              </button>
            </div>
            <button class="btn-outline customize-btn" (click)="openSettings()">
              {{ "shared.gdpr.preview.customize_button" | translate }}
            </button>
          </div>
        </div>
      }

      @case (GdprBannerMode.Settings) {
        <div class="settings-content">
          <h3>{{ "shared.gdpr.settings.title" | translate }}</h3>

          <div class="cookie-group">
            <h4>{{ "shared.gdpr.settings.necessary_title" | translate }}</h4>
            <p>
              {{ "shared.gdpr.settings.necessary_description" | translate }}
            </p>
            <label class="switch">
              <input type="checkbox" checked disabled />
              <span class="slider"></span>
            </label>
          </div>

          <div class="cookie-group">
            <h4>{{ "shared.gdpr.settings.functional_title" | translate }}</h4>
            <p>
              {{ "shared.gdpr.settings.functional_description" | translate }}
            </p>
            <label class="switch">
              <input type="checkbox" [(ngModel)]="functional" />
              <span class="slider"></span>
            </label>
          </div>

          <div class="cookie-group">
            <h4>{{ "shared.gdpr.settings.performance_title" | translate }}</h4>
            <p>
              {{ "shared.gdpr.settings.performance_description" | translate }}
            </p>
            <label class="switch">
              <input type="checkbox" [(ngModel)]="analytics" />
              <span class="slider"></span>
            </label>
          </div>

          <div class="button-row">
            <button class="btn-outline" (click)="cancel()">
              {{ "common.cancel" | translate }}
            </button>
            <button class="btn-filled" (click)="saveConsent()">
              {{ "common.save" | translate }}
            </button>
          </div>
        </div>
      }
    }
  </div>
}
